import { extendTheme } from "@chakra-ui/react"

const Button = {
  baseStyle: {
    _hover: { boxShadow: "none", bg: "transparent" },
    _active: { boxShadow: "none", bg: "transparent" },
    _expanded: { boxShadow: "none", bg: "transparent" },
    _focus: { boxShadow: "none", bg: "transparent" },
  },
}

const Link = {
  baseStyle: {
    boxShadow: "none",
    _active: { boxShadow: "none" },
    _focus: { boxShadow: "none" },
    _hover: { textDecoration: "none" },
  },
}

const Accordion = {
  parts: ["button"],
  baseStyle: {
    button: {
      _hover: { boxShadow: "none", bg: "transparent" },
      _active: { boxShadow: "none" },
      _expanded: { boxShadow: "none" },
      _focus: { boxShadow: "none" },
    },
  },
}

const Select = {
  parts: ["field", "icon"],
  baseStyle: {
    field: {},
    icon: {
      color: "rgba(0, 0, 0, 0.54)",
    },
  },
  defaultProps: {
    variant: "",
  },
}

const Menu = {
  parts: ["list", "item"],
  baseStyle: {
    list: {
      zIndex: "dropdown",
      // zIndex: 11,
    },
    item: {
      _focus: {
        bg: "transparent",
      },
      _hover: {
        bg: "transparent",
      },
    },
  },
}

const theme = {
  fonts: {
    body: "Inter var, sans-serif",
  },
  colors: {
    background: "#FFFFFF",
  },
  zIndices: {
    dropdown: 11,
    menu: 11,
  },
  components: {
    Button,
    Link,
    Accordion,
    Select,
    Menu,
  },
}

export default extendTheme(theme)
